import React from 'react'
import logo from '../assets/LOGO.svg';
import credentials from '../entry-data/credentials.json';

const DashboardPage = () => {
  return (
    <div className="App">
        <img src={logo} alt="logo" />
        <span
            style={{
                paddingTop: '50px',
                fontFamily: 'var(--semibold-text-font-family)',
                color: 'var(--tokens-colors-text-basic)',
                fontSize: 'var(--info-text-font-size)',
                fontWeight: 'var(--bottom-tab-lable-font-weight)',
            }}>
            Здесь будет дашборд. Добро пожаловать, {credentials.login}!
        </span>
    </div>
  )
}

export default DashboardPage